<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                      <div class="card-header-actions">
                        <div class="col-12 card-header-filter-box mb-3">
                          <div class="row align-items-end">
                            <div class="col-lg-3 col-12 col-sm-6 card-header-search-box">
                              <label>{{$t("main.search")}}</label>
                              <div class="input-group">
                                <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                                <div class="input-group-append">
                                  <button class="all-btn search-btn" @click="initList">
                                    <i class="fa fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-12 col-sm-6 card-header-select-box">
                              <div class="form-group m-0">
                                <label>{{$t("common.status")}}</label>
                                <div class="position-relative">
                                  <select class="form-control"
                                          v-model="filter.status"
                                          @change="onChangeStatus">
                                    <option value=""></option>
                                    <option value="NotReady">{{$t("realEstate.status.notReady")}}</option>
                                    <option value="Pending">{{$t("realEstate.status.pending")}}</option>
                                    <option value="AssignedToEvaluator">{{$t("realEstate.status.assignedToEvaluator")}}</option>
                                    <option value="NotFullyEvaluated">{{$t("realEstate.status.notFullyEvaluated")}}</option>
                                    <option value="Evaluated">{{$t("realEstate.status.evaluated")}}</option>
                                    <option value="Confirmed">{{$t("realEstate.status.confirmed")}}</option>
                                    <option value="Rejected">{{$t("realEstate.status.rejected")}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-sm-6 col-12 card-header-select-box">
                              <div class="form-group m-0">
                                <label>Объект тури</label>
                                <div class="position-relative">
                                  <select class="form-control"
                                          v-model="filter.targetType">
                                    <option value=""></option>
                                    <option value="Auto">Автотранспорт</option>
                                    <option value="Building">Бино-иншоатлар</option>
                                    <option value="Fitment">Асбоб-ускуналар</option>
                                    <option value="Asset">Аралаш мол-мулклар</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-sm-6 col-12">
                              <div class="form-group m-0">
                                <label>Объект статус</label>
                                <div class="position-relative">
                                  <select class="form-control"
                                          v-model="filter.targetStatus"
                                          @change="onChangeStatus">
                                    <option value=""></option>
                                    <option value="NotReady">{{$t("realEstate.status.notReady")}}</option>
                                    <option value="Pending">{{$t("realEstate.status.pending")}}</option>
                                    <option value="AssignedToEvaluator">{{$t("realEstate.status.assignedToEvaluator")}}</option>
                                    <option value="NotFullyEvaluated">{{$t("realEstate.status.notFullyEvaluated")}}</option>
                                    <option value="Evaluated">{{$t("realEstate.status.evaluated")}}</option>
                                    <option value="Confirmed">{{$t("realEstate.status.confirmed")}}</option>
                                    <option value="Rejected">{{$t("realEstate.status.rejected")}}</option>
                                    <option value="InIdentification">{{$t("realEstate.status.inIdentification")}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                              <div class="form-group m-0">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                    class="form-control custom-zoom"
                                    format="dd/MM/yyyy"
                                    v-model="filterStartDate"
                                    :clear-button="true"
                                ></datepicker>
                              </div>
                            </div>
                            <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                              <div class="form-group m-0">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                    class="form-control custom-zoom"
                                    format="dd/MM/yyyy"
                                    v-model="filterEndDate"
                                    :clear-button="true"
                                ></datepicker>
                              </div>
                            </div>
                            <div class="col-12 justify-content-md-end">
                              <router-link tag="button" class="all-btn add-btn m-0 mb-2 ml-0 ml-xl-auto" to="/expert2/new" v-if="hasPermission('EXPERT2_ADD')">
                                {{$t("action.add")}}
                              </router-link>
                            </div>
                            <div class="col-12 justify-content-md-end card-header-btns-box">
                              <label class="mr-3 mt-3 font-weight-bold" v-if="results && results.total">Жами: {{results.total}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                              <thead>
                                  <tr>
                                      <th>#</th>
                                      <th>{{$t('expert2.field.name')}}</th>
                                      <th>{{$t('expert2.field.organizationName')}}</th>
                                      <th>Қарз олувчи</th>
                                      <th>{{$t('expert2.field.userBank')}}</th>
                                      <th>{{$t('expert2.field.bankName')}}</th>
                                      <th class="text-center">{{$t('expert2.field.approaches')}}</th>
                                      <th>{{$t('expert2.field.status')}}</th>
                                      <th class="text-center">{{$t('expert2.field.documents')}}</th>
                                      <!--<th class="text-center">{{$t('expert2.field.directorEsp')}}</th>-->
                                      <th class="text-center" v-if="hasPermission('EXPERT2_EDIT')">
                                          {{$t("realEstate.field.action")}}
                                      </th>
                                  </tr>
                              </thead>
                              <tbody v-if="!loading && results && results.data">
                                  <tr v-for="result in results.data" :key="result.id">
                                      <td width="15%" class="text-center">
                                          <div>{{result.id}}</div>
                                          <div v-if="result.evlGoalType" style="font-weight: bold">
                                              {{getGoalType(result.evlGoalType.code)}}
                                          </div>
                                          <div v-if="result.source === 'INSIDE'" class="badge badge-info">{{$t("realEstate.createType.ourselves")}}</div>
                                          <div v-if="result.source === 'ONLINE'" class="badge badge-secondary">{{$t("realEstate.createType.online")}}</div>
                                          <div v-if="result.source === 'API_MIB'" class="badge badge-warning">{{$t("realEstate.createType.apiMib")}}</div>
                                          <div v-if="result.source === 'ANDROID'" class="badge badge-warning">{{$t("realEstate.createType.android")}}</div>
                                          <div v-if="result.source === 'API_BANK'" class="badge badge-warning">{{$t("realEstate.createType.api_bank")}}</div>
                                          <div class="badge badge-warning" v-if="result.targetType === 'Auto' && result.targetId">
                                              {{$t('auto.label')}}: #{{result.targetId}}
                                            <div v-if="result.evlAmountToPay && result.evlAmountToPay > 0" class="font-italic">
                                              <div v-if="result.evlTaxPercent > 0">
                                                Контракт суммаси + НДС({{result.evlTaxPercent | currency('', 0, { thousandsSeparator: ' ' })}}%): <br/> {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                              </div>
                                              <div v-else>
                                                Контракт суммаси: {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                              </div>
                                              <div>Тўланган сумма: {{result.paidAmount | currency('', 0, { thousandsSeparator: ' ' })}} сўм</div>
                                              <div class="badge badge-success" v-if="result.paidAmount >= result.evlAmountToPay">Тўланган</div>
                                              <div class="badge badge-warning" v-else-if="result.paidAmount > 0">Қисман тўланган</div>
                                              <div class="badge badge-danger" v-else>Тўланмаган</div>
                                            </div>
                                          </div>
                                          <div v-else-if="result.targetType === 'Building' && result.targetId">
                                              <div class="badge badge-primary">{{$t('realEstate.name')}}: #{{result.targetId}}</div>
                                              <div v-if="result.evlAmountToPay && result.evlAmountToPay > 0" class="font-italic">
                                                  <div v-if="result.evlTaxPercent > 0">
                                                      Контракт суммаси + НДС({{result.evlTaxPercent | currency('', 0, { thousandsSeparator: ' ' })}}%): <br/> {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                                  </div>
                                                  <div v-else>
                                                      Контракт суммаси: {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                                  </div>
                                                  <div>Тўланган сумма: {{result.paidAmount | currency('', 0, { thousandsSeparator: ' ' })}} сўм</div>
                                                  <div class="badge badge-success" v-if="result.paidAmount >= result.evlAmountToPay">Тўланган</div>
                                                  <div class="badge badge-warning" v-else-if="result.paidAmount > 0">Қисман тўланган</div>
                                                  <div class="badge badge-danger" v-else>Тўланмаган</div>
                                              </div>
                                          </div>
                                          <div class="badge badge-info" v-else-if="result.targetType === 'Fitment' && result.targetId">
                                              {{$t('fitment.label')}}: #{{result.targetId}}
                                            <div v-if="result.evlAmountToPay && result.evlAmountToPay > 0" class="font-italic">
                                              <div v-if="result.evlTaxPercent > 0">
                                                Контракт суммаси + НДС({{result.evlTaxPercent | currency('', 0, { thousandsSeparator: ' ' })}}%): <br/> {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                              </div>
                                              <div v-else>
                                                Контракт суммаси: {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                              </div>
                                              <div>Тўланган сумма: {{result.paidAmount | currency('', 0, { thousandsSeparator: ' ' })}} сўм</div>
                                              <div class="badge badge-success" v-if="result.paidAmount >= result.evlAmountToPay">Тўланган</div>
                                              <div class="badge badge-warning" v-else-if="result.paidAmount > 0">Қисман тўланган</div>
                                              <div class="badge badge-danger" v-else>Тўланмаган</div>
                                            </div>
                                          </div>
                                          <div class="badge badge-success" v-else>
                                               {{$t('asset.name')}}: #{{result.targetId}}
                                          </div>
                                          <real-estate-status :status="result.targetStatus" />
<!--                                          <div class="badge badge-warning">{{statusName(result.targetStatus)}}</div>-->
                                          <div class="text-secondary" v-if="result.statusChangeDate">{{$t('expert2.action.reject')}}: <br> {{new Date(result.statusChangeDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-secondary" v-if="result.pendingDate">{{$t('expert2.action.pending')}}: <br> {{new Date(result.pendingDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                      </td>
                                      <td>{{result.name}}</td>
                                      <td>{{result.organizationName}}</td>
                                      <td>
                                        <span v-if="result.borrower">{{result.borrower.borrowerName}}</span>
                                      </td>
                                      <td>{{result.bankPhone}}</td>
                                      <td>{{result.clientDto != null ? result.clientDto.firmName: ""}}</td>
                                      <!--<td>{{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}</td>-->
                                      <td class="text-center">
                                          <div v-if="result.approachCost">
                                              <span class="badge badge-success">{{$t('expert2.approach.expense')}}</span>
                                          </div>
                                          <div v-if="result.approachIncome">
                                              <span class="badge badge-warning">{{$t('expert2.approach.income')}}</span>
                                          </div>
                                          <div v-if="result.approachComparative" >
                                              <span class="badge badge-info">{{$t('expert2.approach.comparative')}}</span>
                                          </div>
                                      </td>
                                      <td class="text-center">
                                          <div class="badge badge-danger" v-if="result.status ==='NotReady'">{{$t("expert2.status.notReady")}}</div>
                                          <div class="badge badge-secondary" v-else-if="result.status ==='Pending'">{{$t("expert2.status.pending")}}</div>
                                          <div class="badge badge-warning" v-else-if="result.status ==='NotFullyEvaluated'">{{$t("expert2.status.notFullyEvaluated")}}</div>
                                          <div class="badge badge-warning" v-else-if="result.status ==='Confirmed'">{{$t("realEstate.status.confirmed")}}</div>
                                          <div class="badge badge-danger" v-else-if="result.status==='Rejected'">{{$t("realEstate.status.rejected")}}</div>
                                          <div class="badge badge-secondary" v-else-if="result.status==='AssignedToEvaluator'">{{$t("realEstate.status.assignedToEvaluator")}}</div>
                                          <div class="badge badge-info" v-else-if="result.status==='Evaluated'">{{$t("realEstate.status.evaluated")}}</div>
                                          <div class="text-info" v-if="result.status ==='Confirmed' && result.confirmedDate">{{new Date(result.confirmedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-info" v-else-if="(result.status ==='AssignedToEvaluator' || result.status ==='NotFullyEvaluated') && result.assignedToEvaluatorDate">{{new Date(result.assignedToEvaluatorDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-info" v-else-if="result.status ==='Evaluated'">{{new Date(result.estimatedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-info" v-else-if="result.status ==='Pending'">{{new Date(result.pendingDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-info" v-else-if="result.status ==='Rejected'">{{new Date(result.statusChangeDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-info" v-else>{{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                      </td>
                                      <td class="text-center">
                                          <router-link  :to="{path: '/expert2/requirement/edit/' + result.id, query: {hasEdit: false}}"
                                                       class="all-btn dark-btn table-action"
                                                       v-if="result.targetType === 'Building' && hasPermission('EXPERT2_EDIT')">
                                              <i class="fa fa-table"></i>
                                              <span>{{$t('expert2.field.act')}}</span>
                                          </router-link>
                                          <router-link  :to="{path: '/expert2/'+result.id+'/auto/requirement/new', query: {hasEdit: true, objectType: result.targetType}}"
                                                        class="all-btn dark-btn table-action"
                                                        v-else-if="result.targetType === 'Auto' && hasPermission('EXPERT2_EDIT')">
                                              <i class="fa fa-table"></i>
                                              <span>{{$t('expert2.field.act')}}</span>
                                          </router-link>
                                          <router-link  :to="{path: '/expert2/'+result.id+'/fitment/requirement/new', query: {hasEdit: true, objectType: result.targetType}}"
                                                        class="all-btn dark-btn table-action"
                                                        v-else-if="result.targetType === 'Fitment' && hasPermission('EXPERT2_EDIT')">
                                              <i class="fa fa-table"></i>
                                              <span>{{$t('expert2.field.act')}}</span>
                                          </router-link>
                                          <router-link  :to="{path: `/expert2/asset/requirement/edit/${result.id}`, query: {hasEdit: true}}"
                                                        class="all-btn dark-btn table-action"
                                                        v-else-if="result.targetType === 'Asset' && hasPermission('EXPERT2_EDIT')">
                                              <i class="fa fa-table"></i>
                                              <span>{{$t('expert2.field.act')}}</span>
                                          </router-link>
                                      </td>
                                      <!--<td></td>-->
                                      <td class="td-actions text-center">
                                        <template v-if="result.targetType === 'Building' && hasPermission('EXPERT2_EDIT')">
                                          <template v-if="result.createdDate && new Date(result.createdDate) < new Date('2026-07-20')">
                                            <router-link :to="'/expert2/edit/' + result.id"
                                                         class="all-btn edit-btn table-action"
                                            >
                                              <i class="fa fa-edit"></i>
                                            </router-link>
                                          </template>
                                          <template v-else>
                                            <router-link :to="'/expert2/real-estate/edit/' + result.id"
                                                         class="all-btn edit-btn table-action"
                                            >
                                              <i class="fa fa-edit"></i>
                                            </router-link>
                                          </template>
                                        </template>
                                          <router-link :to="'/expert2/auto/edit/' + result.id"
                                                       class="all-btn edit-btn table-action"
                                                       v-else-if="result.targetType === 'Auto' && hasPermission('EXPERT2_ASSET_EDIT')">
                                              <i class="fa fa-edit"></i>
                                          </router-link>
                                          <router-link :to="'/expert2/fitment/edit/' + result.id"
                                                       class="all-btn edit-btn table-action"
                                                       v-else-if="result.targetType === 'Fitment' && hasPermission('EXPERT2_ASSET_EDIT')">
                                              <i class="fa fa-edit"></i>
                                          </router-link>
                                          <router-link :to="'/expert2/asset/edit/' + result.id"
                                                       class="all-btn edit-btn table-action"
                                                       v-else-if="result.targetType === 'Asset' && hasPermission('EXPERT2_ASSET_EDIT')">
                                              <i class="fa fa-edit"></i>
                                          </router-link>
                                          <button class="all-btn info-btn table-action" @click="onShowAuditModal(result)">
                                            <i class="fa fa-list-alt"></i>
                                          </button>
                                          <button class="all-btn view-btn table-action"
                                                  v-if="result.status === 'Confirmed' && !result.bitrix24DealId && hasPermission('EXPERT2_ESTATE_SEND_TO_BITRIX24')"
                                                  v-tooltip="'Битрикс24 га юбориш'"
                                                  :disabled="processing"
                                                  @click="onToSendBitrix24(result.id)"
                                          >
                                            <i class="fa fa-send-o"></i>
                                          </button>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <b-modal v-model="showAuditModal" size="lg" hide-footer>
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                    <object-history-view :entity-type="'DB_EXPERT2'" :entity-id="expert2Id"/>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import {EVL_GOAL_TYPES} from '@/shared/constants/realEstate'
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import Datepicker from 'vuejs-datepicker';
    import ObjectHistoryView from "@/components/common/ObjectHistoryView.vue";
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import RealEstateStatus from "@/components/real-estate/RealEstateStatus.vue";
    export default {
        name: "Expert2List",
        components: {
            RealEstateStatus,
            ObjectHistoryView,
            Datepicker,
            'b-pagination': bPagination,
            'b-modal': bModal,
        },
        directives: {
          'b-modal': bModalDirective
        },
        data() {
            return {
                filter: initFilterModel(),
                showAuditModal: false,
                goalTypes: EVL_GOAL_TYPES,
                loading: false,
                processing: false,
                results: null,
                filterStartDate: null,
                filterEndDate: null,
                expert2Id: null
            }
        },
        methods: {
            initList() {
                this.loading = true;

                if (this.filter.status === "") {
                    this.filter.status = null
                }
                this.filter.startDate = null
                this.filter.endDate = null

                if(this.filterStartDate) {
                  this.filter.startDate = new Date(this.filterStartDate.getFullYear(), this.filterStartDate.getMonth(), this.filterStartDate.getDate() + 1);
                  this.filter.startDate.setUTCHours(0, 0, 0, 0);
                }
                if(this.filterEndDate) {
                  this.filter.endDate = new Date(this.filterEndDate.getFullYear(), this.filterEndDate.getMonth(), this.filterEndDate.getDate() + 2);
                  this.filter.endDate.setUTCHours(0, 0, 0, 0);
                }

                this.$http.post('admin/expert2/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    })
            },
            getGoalType(type) {
                const goals = this.goalTypes.filter((t) => t.key === type);
                return goals.length > 0 ? goals[0].name : '';

            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onChangeStatus() {
                this.filter.page.page = 1;
                this.initList()
            },
            statusName(status) {
                let name = ''
                if (status === 'NotReady') {
                    name = this.$t("expert2.status.notReady")
                } else if (status === 'Pending') {
                    name = this.$t("expert2.status.pending")
                } else if (status === 'NotFullyEvaluated') {
                    name = this.$t("expert2.status.notFullyEvaluated")
                } else if (status === "Confirmed"){
                    name = this.$t("realEstate.status.confirmed")
                } else if (status === "Rejected") {
                    name = this.$t("realEstate.status.rejected")
                } else if (status === "AssignedToEvaluator" || status === "Unreviewed") {
                    name = this.$t("realEstate.status.assignedToEvaluator")
                } else if (status === "Evaluated" || status === "Rated") {
                    name = this.$t("realEstate.status.evaluated")
                } else if (status === "SentToComplement") {
                    name = this.$t("realEstate.status.sentToComplement")
                }

                return name;
            },
            onShowAuditModal(expert2) {
              this.expert2Id = expert2.id
              this.showAuditModal = true
            },
            onToSendBitrix24(id) {
              this.processing = true;
              this.$http.get('bitrix24/' + id + '/' + 'DB_EXPERT2',)
                  .then(res => {
                    if (res.status === 200) {
                      this.initList()
                    }

                    this.processing = false;

                  }).catch(({response}) => {
                console.log('error')
                console.log(response)

                this.$swal({
                  type: 'error',
                  title: '',
                  text: response.data.message ? response.data.message : response.data
                });

                this.processing = false;
              })
            }
        },
        created() {
            var d = new Date();
            var currMonth = d.getMonth();
            var currYear = d.getFullYear();
            this.filterStartDate = new Date(currYear, currMonth, 1);
            this.filterEndDate = new Date(currYear, currMonth, d.getDate());

            this.initList()
        }
    }
</script>

<style scoped>

</style>